import { BaseContainerModel } from '../../base-container.model';
import {
  bl_dgmkt_treatment_hdr_RowClass,
  bl_dgmkt_treatment_ext_RowClass,
  bl_dgmkt_project_line_RowClass,
} from '../../../dbschema';

export class DgMktTreatmentContainerModel extends BaseContainerModel {
  bl_dgmkt_treatment_hdr: bl_dgmkt_treatment_hdr_RowClass =
    new bl_dgmkt_treatment_hdr_RowClass();
  bl_dgmkt_treatment_exts: bl_dgmkt_treatment_ext_RowClass[] = [];
  bl_dgmkt_treatment_lines: bl_dgmkt_project_line_RowClass[] = [];
}
